<template>
  <div class="home">
    <h1>Executive Orderz</h1>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>
